// Account API — authenticated calls to qtz-account backend.
// Proxied via /account (see vite.config.ts).

import { useAuthStore } from '@/stores/authStore'

const BASE = import.meta.env.VITE_BASE_URL ?? ''

export interface OrgInfo {
  id: string
  name: string
  plan: string
  // Optional emblem URL supplied by the organisation (sidebar workspace block).
  logo_url?: string | null
  created_at: string
  updated_at: string
}

export interface UserInfo {
  id: string
  organization_id: string
  email: string
  role: string
  last_login_at?: string
  created_at: string
}

async function get<T>(path: string): Promise<T> {
  const token = useAuthStore.getState().accessToken
  const headers: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {}
  const resp = await fetch(`${BASE}${path}`, { headers })
  const body = (await resp.json().catch(() => ({}))) as {
    success?: boolean
    data?: T
    error?: { message?: string }
  }
  if (!resp.ok) {
    throw new Error(`[${resp.status}] ${body?.error?.message ?? resp.statusText}`)
  }
  // qtz-account wraps all responses in { success: true, data: { ... } }
  return (body.data ?? body) as T
}

export const accountApi = {
  getOrg(orgId: string): Promise<OrgInfo> {
    return get(`/account/api/v1/organizations/${orgId}`)
  },

  getUser(orgId: string, userId: string): Promise<UserInfo> {
    return get(`/account/api/v1/organizations/${orgId}/users/${userId}`)
  },
}
